export const CSS_VARIABLES = 'cal-css-variables';
export const FULL_COMPOSE_FEATURE = 'cal-fullCompose';
export const GET_FREEBUSY_FROM_LAS = 'cal-getFreeBusyfromLAS';
export const GUIDED_CAPTURE_FEATURE = 'cal-qc-guidedCapture';
export const GUIDED_CAPTURE_FULL_CONTAINER_FEATURE = 'cal-qc-guidedCaptureFullContainer';
export const GUIDED_CAPTURE_V2_SUBJECT_FEATURE = 'cal-qc-guidedCaptureV2Subject';
export const GUIDED_CAPTURE_FEEDBACK_AUTOCOLLECTION = 'cal-qc-guidedCaptureFeedbackAutoCollection';
export const MOVE_CALENDAR_EVENT_FEATURE = 'cal-qc-moveCalendar';
export const NOTIFICATIONS_EXPANDCALENDAREVENT_FEATURE = 'cal-notifications-expandCalendarEvent';
export const PPF_CELEBRATION_FEATURE = 'cal-ppf-celebration';
export const INTERESTING_CALENDARS_FEATURE = 'cal-interestingCalendar';
export const MEETINGFORM_LOCATIONWELL_SHOW_FREEBUSY = 'cal-mf-locationWellShowFreeBusy';
export const MEETINGFORM_UPDATE_CONFIRM_BUSY_LOCATION = 'cal-mf-locationBusyConfirmation';
